export function getGetUserReducer(state, action) {
	return {
		...state,
		isLoading: action.isLoading,
		isFetchingAccountData: true,
	};
}
